import { IonContent } from "@ionic/react";
import UserSignInComponent from "../../components/UserSignInComponent";
import SignInHeader from "./components/SignInHeader"
import UserMobileOrEmailInput from "./components/UserMobileOrEmailInput"

function Login(){
    return (
        <>
        <IonContent className="Loginpage">
        <UserSignInComponent>
                        <SignInHeader/>
                        <UserMobileOrEmailInput/>
            </UserSignInComponent>
        </IonContent>
            
        </>
    )
}

export default Login;